import type { QnAStateType } from '@uber/react-qna-lib';
import { atom } from 'jotai';
export type CachedQuestionnaireResponse = {
  status: 'success';
  questionnaire: QnAStateType;
} | {
  status: 'error';
  error: Error;
};
export type CachedQuestionnaireStatus = CachedQuestionnaireResponse | {
  status: 'loading';
};
export const questionnaireDetailsMapAtom = atom<Record<string, CachedQuestionnaireStatus>>({});